module.exports = "<a class=\"cursor-pointer\" (click)=\"goBack()\">\n    <i class=\"fas fa-arrow-left {{ goBackClass }}\"></i>\n</a>"